export function sortTeams(teams) {
  return teams.sort((a, b) => { return a.accountName >= b.accountName ? 1 : -1 })
}
